import React from 'react';
import reactStringReplace from 'react-string-replace';
import {useCountdownTo} from '../../../../data/hooks/datetimeHooks';

// NOTE: make sure src/components/screens/EventHomeScreen/common/EventProgramSection/innerElements/CountdownTo.jsx matches

const Time = ({timestamp, i18n, primary_color}) => {
    const {diff, days, hours, minutes, seconds} = useCountdownTo(timestamp);

    if (diff <= 0) {
        return (
            <p className={'time'} style={{color: primary_color}}>
                {i18n['label.programme.live'] || 'Live!'}
            </p>
        );
    } else if (hours >= 36 && days > 1) {
        let formatted = reactStringReplace(i18n['label.days.future'], '{0}', (match, index) => (
            <span className="days" key={index}>
                {days}
            </span>
        ));
        return (
            <p className={'time days'} style={{PaddingLeft: 10}}>
                {formatted}
            </p>
        );
    } else if (hours > 0) {
        return (
            <p className={'time'} style={{PaddingLeft: 10}}>
                {hours.toString().padStart(2, '0')}:{minutes.toString().padStart(2, '0')}
                <small>{seconds.toString().padStart(2, '0')}</small>
            </p>
        );
    } else {
        return (
            <p className={'time'}>
                {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
            </p>
        );
    }
};

export default Time;